/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { LocationResponse } from 'src/pages/Locations/types';
import QueryKeys from '../config';
import API from '../../../network';

const useLocations = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.LOCATIONS,
    queryFn: async () => API.getInstance().fetchLocations().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const locationsOptions: { label: string; value: string }[] = React.useMemo(
    () => data?.map((option: LocationResponse) => ({
      label: (option.value || '').trim(),
      value: String(option.id),
    })).filter((option) => option.value && option.label) || [],
    [data],
  );

  return {
    locationsLoading: isLoading,
    locationsOptions,
    data,
    error,
    fetchLocations: refetch,
  };
};

export {
  useLocations,
};
